module.exports = __webpack_public_path__ + "img/fsni_7.c7897cca.jpg";